module.exports = __webpack_public_path__ + "img/schedule3.f2f2b071.png";